import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { Invoice } from "src/app/shared/models/DTO/VenueFinance.dto";

@Component({
	selector: "app-invoice-dashboard",
	templateUrl: "./invoice-dashboard.component.html",
	styleUrls: ["../../commandcenter.scss"],
})
export class InvoiceDashboardComponent implements OnInit {
	@Input() invoice: Invoice;
	@Output() invoiceChange = new EventEmitter<Invoice>();

	billedThisMonth: number = 0;
	openBalance: number = 0;

	constructor(public app: AppService, public venueService: OOVenueService) {}

	ngOnInit(): void {
		this.venueService.venueFinance.subscribe((data) => {
			if (data.invoices) {
				this.buildDashboard(data.invoices);
			}
		});

		if (this.venueService.venueFinance.value.invoices) {
			this.buildDashboard(this.venueService.venueFinance.value.invoices);
		}
	}

	buildDashboard(invoiceList: Invoice[]) {
		this.openBalance = 0;
		this.billedThisMonth = 0;
		invoiceList.forEach((invoice) => {
			this.openBalance += invoice.balanceDue;
			if (this.app.moment(invoice.createdDate).isSameOrAfter(this.app.moment().startOf("month"))) {
				this.billedThisMonth += invoice.total;
			}
		});
	}
}
